<template>
  <div>
    <Overview
      v-if="
        satContent && satContent.Tools 
      "
      :satContent="satContent"
      :notifications="notifications"
      :activeTabFromQuery="activeTab"
      @inputChangedInAccount="inputChangedInAccount"
      @changesSavedOrCancelledInAccount="changesSavedOrCancelledInAccount"
      ref="overviewComponent"
    />
    <popup-modal ref="popup">
      <p>
        You have not saved changes to your account. If you don’t save them
        before leaving the page, you will lose them.
      </p>
      <p>Are you sure you want to leave?</p>
      <div class="d-flex">
        <a role="button" tabindex="0" class="cancel mr-auto my-auto" @click="cancelPopup" @keydown.enter="cancelPopup">Cancel</a>
        <button  class="cta-green-169" @click="confirmPopup"  @keydown.enter="confirmPopup">
          OK<span class="angle-right-green"></span>
        </button>
      </div>
    </popup-modal>

    <!-- <div style="text-align:left;margin-top:8em;border-top:5px solid black">
            <h3>Content API</h3>
            <pre>{{ contentJson }}</pre>
        </div>  -->
    <!-- <Register></Register> -->
  </div>
</template>

<script>
//import { dataService } from '../shared';
import Overview from "@/components/Overview";
import { mapActions, mapState } from "vuex";
import {
  GET_SATCONTENTACTION,
  GET_NOTIFICATIONSACTION
} from "../store/mutation-types";
import PopupModal from "../components/popup-modal";

export default {
  name: "SATs",
  components: { Overview, PopupModal },
  data() {
    return {
      unsavedChanges: false
    };
  },
  props: {
    activeTab: {
      type: Number,
      default: () =>0
    }
  },
  async created() {
    //if(this.$route.query.activeTab) this.activeTab= this.$route.query.activeTab;
    await this.loadContent();
    //console.log(this.satContent);
    //this.contentJson = JSON.stringify(this.satContent, null, 2);
    //this.contentJson = JSON.stringify(this.satContent, null, 2);
  },
  methods: {
    ...mapActions([GET_SATCONTENTACTION, GET_NOTIFICATIONSACTION]),
    async loadContent() {
      //this.satContent = await dataService.getSatContent();
      await this.getSatContentAction();
      await this.getNotificationsAction();
    },
    inputChangedInAccount() {
      console.log("inputChangedInAccount");
      this.unsavedChanges = true;
    },
    changesSavedOrCancelledInAccount() {
      this.unsavedChanges = false;
    },
    checkUnsavedChanges(event) {
      if (!this.unsavedChanges) return;
      event.preventDefault();
      event.returnValue = "";
    },
    showPopup() {
      
      this.$refs.popup.open();
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    confirmPopup() {
      this.$refs.popup.close();
      this.resolvePromise(true);
    },

    cancelPopup() {
      this.$refs.popup.close();
      this.resolvePromise(false);
    }
  },
  computed: {
    //...mapState({ satContent: state => state.satContent })
    //...mapState(['satContent']), // all equivalent get state syntax
    ...mapState({ satContent: "satContent", notifications: "notifications" })
    //...mapGetters({ getSectors: 'getSectors' })
  },
  async beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges) {
      const answer = await this.showPopup();
      // const answer = window.confirm(
      //   "You have not saved changes to your account. If you don’t save them before leaving the page, you will lose them.\n\nAre you sure you want to leave?"
      // );
      if (answer) {
        return next();
      } else {
        
        this.$refs.overviewComponent.selectTab(3);
        return next(false);
      }
    } else {
      return next();
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.checkUnsavedChanges);
  }
};
</script>

<style lang="sass" scoped></style>
